import { render, staticRenderFns } from "./DriverLoginReminder.vue?vue&type=template&id=8e741c7a&"
import script from "./DriverLoginReminder.vue?vue&type=script&lang=js&"
export * from "./DriverLoginReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports